const formDefaultValues = {
  general: {
    projectProposalResearchFields: [
      {
        priority: 1,
        researchLine: '',
        researchFieldId: '',
      },
      {
        priority: 2,
        researchLine: '',
        researchFieldId: '',
      },
      {
        priority: 3,
        researchLine: '',
        researchFieldId: '',
      },
    ],
    researchTypesId: '',
    lead: {
      organizationId: '',
      name: '',
      chief: '',
      phone: '',
      fax: '',
      email: '',
      bank: '',
      partnerContribution: '',
      type: 'LEAD',
    },
    partners: [],
    owners: [],
    scientificSecretaries: [],
    mainParticipants: [],
    participants: [],
    technicians: [],
    domesticExperts: [],
    internationalExperts: [],
  },
  expenditure: {
    file: null,
  },
  researchDescription: {
    file: null,
  },
};

export const defaultValues = {
  recommendedExpert: {
    fullname: '',
    researchLine: '',
    workplace: '',
    email: '',
    phone: '',
  },
  softProduct: {
    name: '',
    quantityTarget: undefined,
    note: '',
  },
  hardProduct: {
    name: '',
    qualityCriteria: '',
    measure: '',
    evaluativeCriteria: undefined,
    domesticModelQuality: '',
    internationalModelQuality: '',
    expectedQuantity: undefined,
  },
};

export const secretaryDefaultValues = {
  email: null,
  fullname: null,
  academicRank: null,
  academicDegree: null,
  researchLines: null,
  dob: null,
  gender: null,
  citizenId: null,
  dateOfIssue: null,
  placeOfIssue: null,
  taxIdentificationNumber: null,
  bankAccount: null,
  bank: null,
  organizationId: null,
  specificOrganizationName: null,
  personalPhone: null,
  experience: null,
  workplace: null,
};

export default formDefaultValues;
